import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { fetchCurrentUser, type MeResponse } from '../api/auth';

const HomeRedirect = () => {
  const [me, setMe] = useState<MeResponse | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    fetchCurrentUser()
      .then((resp) => { if (mounted) setMe(resp); })
      .catch(() => { if (mounted) setMe(null); })
      .finally(() => { if (mounted) setLoading(false); });
    return () => { mounted = false; };
  }, []);

  if (loading) return null;

  const role = (me?.role ?? me?.user?.typeKey ?? '') as string;
  if ((role || '').toUpperCase() === 'ADVISOR') {
    return <Navigate to="/crm" replace />;
  }
  return <Navigate to="/dashboard" replace />;
};

export default HomeRedirect;

